


























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { httpClient } from '@/core';
import { env } from '@/env';

@Component({
  name: 'ShareComponent',
  components: { }
})
export default class ShareComponent extends Vue {
    @Prop(String) public documentId: string | undefined;

    private messageText: string;
    private showMessage: boolean;
    private messageColor: string;
    private isError: boolean;

    private redirection: string;

    constructor() {
        super();
        this.messageText = '';
        this.showMessage = false;
        this.messageColor = '';
        this.isError = false;
        this.redirection = 'Redirecting to the document...';
    }

    private async mounted() {
        console.log('call redirecting');
        await this.sharedAction();
    }

    private async sharedAction() {
        await httpClient.instance
        .get(`${env.apiUrl}/documents/${env.applicationId}/shared/${this.documentId}`)
        .then((response) => {
            this.$router.push('/translations/' + this.documentId)
        })
        .catch((error) => {
            this.redirection = 'Error. Redirecting to my documents...';
            if (error.response && error.response.status === 409) {
                this.displayInfo('Error accesing document: ' + error.response.data, true);
            } else {
              this.displayInfo(error.response.data, true);
              console.error('sharedAction error', error);
            }
            setTimeout(() => {
              this.$router.push('/translations')
            }, 15000);
        })
    }

  private displayInfo(text: string, error: boolean) {
    this.messageText = text;
    this.messageColor = error ? 'error' : 'sgsOrange';
    this.showMessage = true;
    this.isError = error;
    if (error) console.error(text, error);
  }
}
